import { CustomCompletenessSwitch } from "./CustomCompletenessSwitch";

export const customCompletenessUiField = {
  is_abstract: {
    "ui:field": CustomCompletenessSwitch,
  },
};
